import { render, staticRenderFns } from "./howToUseCard.vue?vue&type=template&id=bd72abca&scoped=true&"
import script from "./howToUseCard.vue?vue&type=script&lang=js&"
export * from "./howToUseCard.vue?vue&type=script&lang=js&"
import style0 from "./howToUseCard.vue?vue&type=style&index=0&id=bd72abca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd72abca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd72abca')) {
      api.createRecord('bd72abca', component.options)
    } else {
      api.reload('bd72abca', component.options)
    }
    module.hot.accept("./howToUseCard.vue?vue&type=template&id=bd72abca&scoped=true&", function () {
      api.rerender('bd72abca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/cards/howToUseCard.vue"
export default component.exports